const env = {
    // gqlLink: 'https://dex.dipdup.net/v1/graphql'
    gqlLink: 'https://api.mavenfinance.io/v1/graphql',
    rpcLink: 'https://atlasnet.rpc.mavryk.network',
    rpcTestNetNetwork: 'atlasnet',
    NODE_ENV: 'production',
    // rpcLink: 'https://mainnet.tezos.marigold.dev/',
}

export default env
